import React, { useContext } from "react";
import axios from "axios";
import CustomTag from "../../../../ui/CustomTag";
import { AuthContext } from "../../../../contexts";
import toastOptions from "../../../../assets/constants/toast";
import { toast } from "react-toastify";

const CustomerHeader = ({ customer, onUpdate }) => {
    const { token } = useContext(AuthContext);


    const handleUpdate = (logoUrl = null) => {
        axios
            .put(
                process.env.REACT_APP_UPA_API_HOST + "pennylane/customers/" + customer.id,
                {
                    website: customer.website,
                    logo: logoUrl ? logoUrl : customer.logo,
                },
                { headers: { Authorization: "Bearer " + token } }
            )
            .then((response) => {
                if (response.data) {
                    if (onUpdate) onUpdate();
                    toast.success("Client mis à jour avec succès", toastOptions);
                }
            })
            .catch((error) => console.log(error));
    };

    const uploadNewLogo = (event) => {
        if (event.target.files[0]) {
            const data = new FormData();
            const extension = event.target.files[0].name.split(".").pop();
            data.append("path", "/altelis-tools/customers/" + customer.id + "." + extension);
            data.append("image", event.target.files[0]);
            axios
                .post("https://image.store.altelis.com/api/v1/upload", data)
                .then((response) => {
                    handleUpdate("https://image.store.altelis.com" + response.data.path);
                })
                .catch((err) => console.log(err));
        }
    };

    return (
        <div className="customer-header">
            <div className="customer-header__content">
                <div className="customer-header__logo-wrapper">
                    <label htmlFor="file" className="customer-header__logo">
                        {customer.logo ? (
                            <img src={customer.logo} alt="Logo client" className="customer-header__logo-img" />
                        ) : (
                            <img src="https://image.store.altelis.com/images/altelis-tools/logo-altelis.png" alt="Logo par défaut" className="customer-header__logo-img" />
                        )}
                        <input accept=".png, .jpg, .jpeg, .svg, .webp, .avif" type="file" name="file" id="file" onChange={uploadNewLogo} className="customer-header__logo-input" />
                    </label>
                </div>
                <div className="customer-info">
                    <header className="customer-info__header">
                        <h1 className="customer-info__title">{customer.name}</h1>
                    </header>
                    <div className="customer-info__details">
                        <div className="customer-info__field">
                            <span className="customer-info__label customer-info__label--reference">Référence</span>
                            <CustomTag value={customer.reference || "Non renseigné"} className={!customer.reference ? "deactivated" : ""} />
                        </div>
                        <div className="customer-info__field">
                            <span className="customer-info__label customer-info__label--support">Support</span>
                            <div className="customer-info__support-wrapper">
                                <CustomTag
                                    value={
                                        customer.supportInfo.isMutualized ? "Mutualisé" : customer.supportInfo.isPremium ? "Premium" : customer.supportInfo.isEssential ? "Essentiel" : "Aucun"
                                    }
                                    className={`uppercase ${
                                        customer.supportInfo.isMutualized ? "premium" : customer.supportInfo.isPremium ? "purple" : customer.supportInfo.isEssential ? "blue" : "deactivated"
                                    }`}
                                />
                                <div className="customer-info__support-consumption">
                                    <CustomTag
                                        value={
                                            customer.supportInfo.isMutualized
                                                ? `${(customer.supportInfo.groupInfo?.totalGroupHours || 0).toFixed(1)}h / ${
                                                      customer.supportInfo.groupInfo?.totalAvailableHours || customer.supportInfo.premiumHours
                                                  }h`
                                                : customer.supportInfo.isPremium
                                                ? `${(customer.supportHours || 0).toFixed(1)}h / ${customer.supportInfo.premiumHours}h`
                                                : `${(customer.supportHours || 0).toFixed(1)}h`
                                        }
                                        className={
                                            customer.supportInfo.isMutualized
                                                ? (customer.supportInfo.groupInfo?.totalGroupHours || 0) >
                                                  (customer.supportInfo.groupInfo?.totalAvailableHours || customer.supportInfo.premiumHours)
                                                    ? "no-assistance"
                                                    : "premium"
                                                : customer.supportInfo.isPremium
                                                ? (customer.supportHours || 0) > customer.supportInfo.premiumHours
                                                    ? "no-assistance"
                                                    : "success"
                                                : (customer.supportHours || 0) > 0
                                                ? "no-assistance"
                                                : "success"
                                        }
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CustomerHeader;